module.exports = __webpack_public_path__ + "img/hr-branch-particle-shadow-18.46415a0f.png";